<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">Upload KMZ</span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="manageKMZForm">
            <div class="row mt-3">
                <div class="col-xl-2"></div>
                <div class="col-xl-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Select Service Provider</mat-label>
                        <mat-select class="scrollbarcs" formControlName="serviceproviderId"
                            placeholder="Please select Service Provider">
                            <mat-select-filter [displayMember]="'value'" [array]="serviceProviderList"
                                (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredList1" [value]="item.key"
                                (click)="selectedProvider()" style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-xl-4">
                    <div class="table_search">
                        <mat-form-field appearance="fill" hideRequiredMarker [ngClass]="'searchText-mat-field'"
                            style="margin-bottom: 1rem !important;">
                            <mat-label>Search</mat-label>
                            <div class="search-input-container">
                                <input placeholder="AliasName / ProductId"
                                    id="search" matInput (keyup)="applyFilter($event)" type="text" #searchInput>
                            </div>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-xl-2"></div>
            </div>

            <div class="table-responsive mt-2 mb-4">
                <mat-table #table [dataSource]="dataSource" matSort matSortDirection="asc">
                    <ng-container matColumnDef="check">
                        <mat-header-cell *matHeaderCellDef></mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <mat-checkbox color="primary" class="ml-2"  [checked]="dataField.isChecked"
                                (change)="select(dataField)" ></mat-checkbox>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ProviderName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="name" style="text-align: center;" >Provider
                            Name</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign">
                                {{dataField.name}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ProviderAliasName">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="aliasName">Provider Alias
                            Name</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign">
                                {{dataField.aliasName}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="ProductId">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="productId">Product Id</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign">
                                {{dataField.productId}}</p>
                        </mat-cell>
                    </ng-container>
                    <ng-container matColumnDef="Cost">
                        <mat-header-cell *matHeaderCellDef mat-sort-header="totalAmount">Cost</mat-header-cell>
                        <mat-cell *matCellDef="let dataField">
                            <p class="text-truncate txtalign">
                                {{dataField.totalAmount}}</p>
                        </mat-cell>
                    </ng-container>
                    <mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></mat-header-row>
                    <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple>
                    </mat-row>
                </mat-table>
            </div>
            <div *ngIf="data.length===0" class="text-center">
                No Results Found
              </div>

              <div class="table_pagenation" [hidden]="dataSource?.filteredData.length<=50">
                <mat-paginator #paginator [length]="dataSource?.filteredData.length || 0" [pageIndex]="0" [pageSize]="50"
                    [pageSizeOptions]="[50, 100]">
                </mat-paginator>
            </div>
            <div class="row">
                <div class="col-xl-4"></div>
                <div class="col-xl-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Product Classification</mat-label>
                        <mat-select class="scrollbarcs" formControlName="productClassification"
                            placeholder="Select Product Classification">
                            <mat-select-filter [displayMember]="'value'" [array]="Productkmzlist"
                                (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredList2" [value]="item.key"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-xl-4"></div>
            </div>
            <div class="row mt-3 managekmz">
                <div class="col-xl-4"></div>
                <div class="col-xl-4">
                    <mat-radio-group formControlName="KmzKmlOrExcel">
                        <mat-label class="col-4">File Type</mat-label>
                        <mat-radio-button value="kmzkml" class="col-4"> KMZ/KML</mat-radio-button>
                        <mat-radio-button value="excel" class="col-4"> Excel</mat-radio-button>
                    </mat-radio-group>
                    <div *ngIf="!manageKMZForm.get('KmzKmlOrExcel').valid &&
                    (manageKMZForm.get('KmzKmlOrExcel').dirty ||
                     manageKMZForm.get('KmzKmlOrExcel').touched)" class="text-danger text-center"> Please Select File
                        Type</div>
                </div>
                <div class="col-xl-4"></div>
            </div>

            <div class="row mt-3 managekmz" [hidden]="manageKMZForm.value.KmzKmlOrExcel=='excel'">
                <div class="col-xl-4"></div>
                <div class="col-xl-4">
                    <mat-radio-group formControlName="isExistingKmz">
                        <mat-label class="col-4"> File Nature</mat-label>
                        <mat-radio-button value="false" class="col-4">New</mat-radio-button>
                        <mat-radio-button value="true" class="col-4"> Existing</mat-radio-button>
                        <mat-error *ngIf="!manageKMZForm.get('isExistingKmz').valid &&
                        (manageKMZForm.get('isExistingKmz').dirty ||
                         manageKMZForm.get('isExistingKmz').touched)"> Please Select File Nature</mat-error>
                    </mat-radio-group>
                </div>
                <div class="col-xl-4"></div>
            </div>
            <div class="row mt-3" *ngIf="this.manageKMZForm.value.isExistingKmz=='true'">
                <div class="col-xl-4"></div>
                <div class="col-xl-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Select Existing Kmz</mat-label>
                        <mat-select class="scrollbarcs" formControlName="kmlfiledetailsid"
                            placeholder="Select Product Classification" (click)="selectedkmlfile()">
                            <mat-select-filter [displayMember]="'value'" [array]="kmlfilelist"
                                (filteredReturn)="filteredList3 = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredList3" [value]="item.key"
                                style="overflow-y: scroll !important;">
                                {{item.value}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-xl-4"></div>
            </div>
            <div class="row mt-3">
                <div class="col-xl-4"></div>
                <div class="col-xl-4">
                    <div class="padd-right-file" style="display: flex;">
                        <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                            <mat-label>Attachment</mat-label>
                            <input matInput  id="AttachmentFileName" placeholder="Select Attachment"
                                formControlName="AttachmentFileName" autocomplete="off" specialIsAlphaNumeric
                                class="col-10" autocomplete="off" readonly>
                        </mat-form-field>
                        <button type="button" (click)="selectFile()" *ngIf="!isFileSelected"
                            class="badge bg-light-blue image-button">
                           <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;"/>
                        </button>
                        <button type="button" (click)="reset()" *ngIf="isFileSelected"
                            class="badge bg-light-blue image-button">
                            <img style="filter: invert(1);width: 26px;"
                                src="../../../../assets/Home-Connect/icons/delete.svg" />
                        </button>
                    </div>
                    <div class="mt-3" style="text-align: end;" ng-show="vm.kmz.KmzKmlOrExcel=='kmzkml'">
                        <button type="button" matRipple class="btn btn-primary" (click)="previewChanges()">
                            <i class="fa fa-television" aria-hidden="true"></i> Preview Changes
                        </button>
                    </div>
                </div>
                <div class="col-xl-4"></div>
            </div>
        </form>

        <div class="row mt-5">
            <div class="col-xl-12 text-center">
                <button type="button" matRipple class="btn reset_btn mr-3" (click)="ResetForm()">
                    <i class="fa fa-refresh mr-2"></i> Reset
                </button>
                <button type="button" matRipple class="btn btn-secondary" (click)="save()">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>
